<template>
  <hic-leisure-page style="text-align: center">
    <el-input style="margin-top: 5rem; width: 50rem" autofocus @keyup.enter.native="search" v-model="keyword" clearable>
      <el-button type="primary" slot="append" icon="el-icon-search" @click="search" />
    </el-input>
  </hic-leisure-page>
</template>
<script>
  import { mapGetters, mapMutations } from "sw-hic";
  import api from "./dynamic/api";
  export default {
    props: {
      hideBackground: Boolean,
    },
    data() {
      return {
        keyword: null,
        targetCode: null,
      };
    },
    computed: {
      ...mapGetters(["permission", "user"]),
    },
    mounted() {
      this.init();
    },
    methods: {
      // ...mapMutations(["setUserRoles"]),
      init() {
        api.SiteMap.query({ srcCode: "home" })
          .then((res) => {
            if (!res.items.length) {
              throw "首页查询没有配置目标页！";
            }
            this.targetCode = res.items[0].tgtCode;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      search() {
        if (this.targetCode) {
          this.$router.push({ name: "dynamic", query: { code: this.targetCode, paras: JSON.stringify({ keyword: this.keyword }) } });
        }
      },
    },
  };
</script>
